<template>
  <v-list-item @click="toggleDemoMode">
    <template #prepend>
      <v-icon :icon="isDemoModeEnabled ? mdiEyeOff : mdiEye" />
    </template>
    <v-list-item-title> {{ isDemoModeEnabled ? "Disable" : "Enable" }} Demo Mode </v-list-item-title>
    <v-list-item-subtitle>
      {{ isDemoModeEnabled ? "Show real names and emails" : "Mask personal info for screenshots" }}
    </v-list-item-subtitle>
  </v-list-item>
</template>

<script setup lang="ts">
import { mdiEye, mdiEyeOff } from "@mdi/js";
import { usePrivacyMode } from "@/composables/usePrivacyMode";

const { isDemoModeEnabled, toggleDemoMode } = usePrivacyMode();
</script>
